module.exports = "https://static.energy5.com/_next/static/images/evCharging-041ebcf9853da49b6d19239e1e1c6d84.webp";